import { getYear, format, startOfToday, startOfMonth, addMonths, max, parse, addMinutes } from 'date-fns';
import { formatInTimeZone, utcToZonedTime, toDate, zonedTimeToUtc } from 'date-fns-tz';
import { enGB } from 'date-fns/locale';

export const formatDate = (date: string | Date, dateFormat: string, timeZone: string | undefined = undefined): string => {

    return formatInTimeZone(new Date(date), timeZone ?? 'Europe/London', dateFormat, { locale: enGB });
}

export const year = (date: string | Date): number => {
	return +getYear(new Date(date));
}

export const dateAndTime = (date: string | Date): string => {
    return formatDate(date, "yyyy-MM-dd HH:mm");
}

export const YYYYMMDD = (date: string | Date): string => {
    return formatDate(date, "yyyy-MM-dd");
}

export const HHmm = (date: string | Date): string => {
    return formatDate(date, "HH:mm");
}

export const EEEddM = (date: string | Date): string => {
    return formatDate(date, "EEE dd/M");
}

export const ISO8601 = (date: string): string => {
	return formatDate(date, "yyyy-MM-dd'T'HH:mm:ss");
}

export const EEE_dd_MMM_YYYY = (date: string | Date): string => {
    return formatDate(date, "EEE dd MMM yyyy");
}

export const EEEddMMMYYYY = (date: string | Date): string => {
    return formatDate(date, "EEE dd/MMM/yyyy");
}

export const EEEEddMMMM = (date: string | Date): string => {
    return formatDate(date, "EEEE dd MMMM");
}

export const EEEddMMMyy = (date: string | Date): string => {
    return formatDate(date, "EEE dd MMM yy");
}

export const EEEddMMMyyyy = (date: string | Date): string => {
    return formatDate(date, "EEE dd MMM yyyy");
}

export const EEEE = (date: string | Date): string => {
    return formatDate(date, "EEEE");
}

export const ddLLL = (date: string | Date): string => {
    return formatDate(date, "dd LLL");
}

export const today = (): Date => {
    return startOfToday();
}

export const addMonthsFromDate = (date: Date, amount: number) => {
    return addMonths(date, amount);
}

export const maxDate = (dates: Date[]) => {
    return max(dates);
}

export const getDurationInMinutes = (fromDate: string | Date, toDate: string | Date) => {
    let diff = (new Date(toDate).valueOf() - new Date(fromDate).valueOf()) / 1000;
    diff /= 60;

    return Math.abs(Math.round(diff));
}

export const toLocaleDateString = (date: string | Date) => {
    return formatDate(date, "dd/MM/yyyy");
}

export const toBritishDate = (date: string, format: string) => {
    return zonedTimeToUtc(parse(date, format, new Date()), 'Europe/London');
}

export const fromLocaleDate = (date: string) => {
    try {
        const parsedDate = parse(date, 'dd/MM/yyyy', new Date(), {
            locale: enGB
        })

        return YYYYMMDD(parsedDate);
    } catch (err: unknown) {
        return YYYYMMDD(date);
    }
}

export const ukNow = () : Date => {
	
	const now = new Date().toISOString();
	return utcToZonedTime(toDate(now), 'Europe/London');
}

export const parseDate = (dateString: string, format: string) => {
    return parse(dateString, format, new Date(), { locale: enGB });
}

export const datePart = (date : Date) => {
	
	const year = date.getFullYear();
  	const month = (date.getMonth() + 1).toString().padStart(2, '0');
  	const day = date.getDate().toString().padStart(2, '0');

  	return `${year}-${month}-${day}`;
}
